<template>
  <v-form ref="form_8">
    <router-view></router-view>
    <ShowErrors />
    <v-layout
      row
      xs12
      class="py-4 justify-center"
      v-if="complete !== true"
    >
      <v-btn
        @click="setPreviousStep()"
        class="accent_light"
      >
        <v-icon class="reverse">arrow_right_alt</v-icon>
        Previous
      </v-btn>
      <v-btn
        @click="completeBooking()"
        :disabled="testCompleteStep(getFormIndexByPath('/payment')) === false"
        class="accent"
      >
        BOOK NOW
        <v-icon>arrow_right_alt</v-icon>
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import store from "../../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import ShowErrors from "@/components/pages/ShowErrors.vue";

export default {
  name: "FormPayment",
  props: [],
  store: store,
  mixins: [BookingFormMixin, Shared],
  components: {ShowErrors},
  mounted() {
    const step = this.getStepNumberByPath("/booking/payment");
    if (store.state.active !== step) {
      store.commit("setActiveStep", step);
    }
  }
};
</script>
